import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ActionHandlerFunction, PaginationItem } from "@preveil-api";
import { DriveUIActionTypes, QueryParamKeys, QueryParamValues } from "src/common";
import { Icon, Pagination, PaginationDisplay, ToolbarButton, ToolbarWrapper, ToolbarFilter } from "src/components";

type AllProps = {
  is_loading: boolean;
  pagination?: PaginationItem;
  selected: string[];
  counts?: number;
  handleAction: ActionHandlerFunction;
}

function ToolbarComponent(props: AllProps) {
  const { is_loading, pagination, selected, counts, handleAction } = props;
  const [search_params, setSearchParams] = useSearchParams();
  // NOTE: to enable it for internal users: /drive/watched/root?action=enable_clear_all to see the clear all button
  const [enable_clear_all, setEnableClearAll] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [filter_param, setFilterParam] = useState<string>("");

  useEffect(() => {
    const page_action_qs = search_params.get(QueryParamKeys.PAGE_ACTION_QUERY_KEY);
    if (!!page_action_qs && page_action_qs === QueryParamValues.enable_clear_all) {
      search_params.delete(QueryParamKeys.PAGE_ACTION_QUERY_KEY);
      setSearchParams(search_params);
      setEnableClearAll(true);
    }
  }, []);

  useEffect(() => {
    (!!pagination && pagination.totalRows > 0) ?
      setDisabled(selected.length <= 0) : setDisabled(true);
  }, [selected, pagination]);

  // Description: reset filters on pagination and on click of x
  function resetFilters() {
    setFilterParam("");
    handleAction({ actionType: DriveUIActionTypes.Filter, params: "" });
  }

  return <ToolbarWrapper
    leftContent={<ToolbarFilter
      disabled={is_loading || counts === 0}
      placeholder="Filter by items name in this page..."
      filter_param={filter_param}
      onChange={(value) => { setFilterParam(value); handleAction({ actionType: DriveUIActionTypes.Filter, params: value }); }}
      onClick={resetFilters} />}
    pagination={!!pagination ? <Pagination pagination={pagination} handleAction={(params) => { resetFilters(); handleAction(params); }} /> : <></>}
    paginationInfo={!!pagination ? <PaginationDisplay pagination={pagination} /> : <></>}
    refreshAction={() => { resetFilters(); handleAction({ actionType: DriveUIActionTypes.Refresh }); }}
    refreshTooltipContent="Refresh Current Folder"
    isLoading={is_loading}
  >
    <ToolbarButton
      disabled={disabled}
      onClick={() => handleAction({ actionType: DriveUIActionTypes.Unwatch, params: selected })}
      ariaLabel="Unwatch Selected"
      tooltipContent="Unwatch Selected">
      <Icon className="ficon-eye-off" />
    </ToolbarButton>
    {enable_clear_all ? <ToolbarButton
      disabled={!counts}
      onClick={() => handleAction({ actionType: DriveUIActionTypes.ClearAllWatched, params: selected })}
      ariaLabel="Clear All Watched"
      tooltipContent="Clear All Watched">
      <Icon className="ficon-trash-2" />
    </ToolbarButton> : <></>}
  </ToolbarWrapper>;
}

export default React.memo(ToolbarComponent);
